// Delivery fees (in DA) — departure from Annaba
// Anchors: Algiers = 700 home / 400 office, based on ~600km road distance
// All wilayas scaled by road distance + accessibility from Annaba

export const DELIVERY_FEES = {

  // --- Annaba & immediate neighbors (0–100km) ---
  "Annaba":           { home: 500,  office: 300 },  // local
  "El Tarf":          { home: 500,  office: 300 },  // ~50km
  "Guelma":           { home: 500,  office: 300 },  // ~80km
  "Souk Ahras":       { home: 550,  office: 350 },  // ~100km

  // --- Northeast corridor (100–250km) ---
  "Skikda":           { home: 550,  office: 350 },  // ~100km
  "Constantine":      { home: 600,  office: 350 },  // ~170km
  "Oum El Bouaghi":   { home: 600,  office: 350 },  // ~200km
  "Mila":             { home: 600,  office: 350 },  // ~200km
  "Tébessa":          { home: 600,  office: 350 },  // ~220km
  "Khenchela":        { home: 600,  office: 350 },  // ~230km
  "Jijel":            { home: 650,  office: 400 },  // ~230km

  // --- Center-East (250–450km) ---
  "Sétif":            { home: 650,  office: 400 },  // ~280km
  "Batna":            { home: 650,  office: 400 },  // ~280km
  "Bordj Bou Arreridj": { home: 650, office: 400 }, // ~350km
  "Béjaïa":           { home: 650,  office: 400 },  // ~350km
  "Bouira":           { home: 700,  office: 400 },  // ~420km
  "Tizi Ouzou":       { home: 700,  office: 400 },  // ~460km
  "Biskra":           { home: 650,  office: 400 },  // ~300km
  "M'Sila":           { home: 650,  office: 400 },  // ~380km

  // --- Algiers & surroundings (~600km anchor) ---
  "Alger":            { home: 700,  office: 400 },  // anchor
  "Boumerdès":        { home: 700,  office: 400 },  // ~580km
  "Blida":            { home: 700,  office: 400 },  // ~620km
  "Tipaza":           { home: 750,  office: 450 },  // ~650km
  "Médéa":            { home: 750,  office: 450 },  // ~650km
  "Aïn Defla":        { home: 750,  office: 450 },  // ~680km
  "Chlef":            { home: 750,  office: 450 },  // ~700km

  // --- West (700–900km from Annaba) ---
  "Djelfa":           { home: 750,  office: 450 },  // ~650km
  "Tiaret":           { home: 800,  office: 500 },  // ~780km
  "Relizane":         { home: 800,  office: 500 },  // ~800km
  "Mostaganem":       { home: 800,  office: 500 },  // ~820km
  "Mascara":          { home: 800,  office: 500 },  // ~830km
  "Tissemsilt":       { home: 800,  office: 500 },  // ~800km
  "Oran":             { home: 850,  office: 550 },  // ~870km
  "Sidi Bel Abbès":   { home: 850,  office: 550 },  // ~880km
  "Aïn Témouchent":   { home: 850,  office: 550 },  // ~900km
  "Tlemcen":          { home: 900,  office: 550 },  // ~960km
  "Saïda":            { home: 850,  office: 550 },  // ~850km
  "Laghouat":         { home: 750,  office: 450 },  // ~650km
  "Naâma":            { home: 950,  office: 600 },  // ~1050km
  "El Bayadh":        { home: 950,  office: 600 },  // ~1000km

  // --- Deep South (desert/remote) ---
  "El Oued":          { home: 800,  office: 500 },  // ~400km but remote
  "Ouargla":          { home: 900,  office: 600 },  // ~600km desert
  "Touggourt":        { home: 850,  office: 550 },  // ~500km
  "Ouled Djellal":    { home: 850,  office: 550 },  // ~500km
  "El M'Ghair":       { home: 900,  office: 600 },  // ~500km
  "Ghardaïa":         { home: 950,  office: 650 },  // ~700km
  "El Menia":         { home: 1050, office: 700 },  // ~900km
  "Béchar":           { home: 1100, office: 750 },  // ~1300km via highway
  "In Salah":         { home: 1100, office: 750 },  // very remote
  "Timimoun":         { home: 1100, office: 750 },  // very remote
  "Adrar":            { home: 1150, office: 800 },  // ~1600km
  "Tamanrasset":      { home: 1300, office: 900 },  // ~2000km extreme south
  "Tindouf":          { home: 1300, office: 900 },  // far west desert
  "Illizi":           { home: 1300, office: 900 },  // far southeast
  "Djanet":           { home: 1300, office: 900 },  // far southeast
};